import { FuseRouteItemType } from '@fuse/utils/FuseUtils';
import { lazyRetry } from '@utils/lazyRetry';

const DashboardAPP = lazyRetry(() => import('./DashboardApp'));
const HomeTab = lazyRetry(() => import('./tabs/home/HomeTab'));
const PerformanceTab = lazyRetry(() => import('./tabs/performance/PerformanceTab'));

const DashboardAPPRoute: FuseRouteItemType = {
  path: 'dashboard',
  element: <DashboardAPP />,
  children: [
    { path: '', element: <HomeTab /> },
    { path: 'performance', element: <PerformanceTab /> }
  ]
};

export default DashboardAPPRoute;
